<my-feedback [index]="9999" [title]="topTitle" [show]="show" [body]="employee_select" [bodyStyle]="{ width: '894px' }"
  (sure)="putResult()" (cancel)="close()" [sureText]="sureText" [cancelText]="cancelText">
  <ng-template #employee_select>
    <!--    如果当前模式是选择管理岗-->
    <div class="select-box flexRow pl-xl pr-xl pt-lg pb-md">
      <div class="border-1 select-body selfRadius flexRow">
        <div class="options-box flexFull border-right-1 flexColumn">
          <!--            顶部title-->
          <div class="box-title pl-12 flexRow">
            <div class="text-center mr-12 clickEle" style="width: 52px" [ngClass]="{ 'check-tab': !isAll }"
              (click)="isAll = false" *ngIf="hasRecommend">
              {{ recommendTitle }}
            </div>
            <div class="clickEle text-center" style="width: 72px" [ngClass]="{ 'check-tab': isAll }"
              (click)="isAll = true" *ngIf="showAll">
              {{ model == 'admin' ? '全部管理' : '全部人员' }}
            </div>
          </div>
          <!--            顶部title End-->
          <!--            中部搜索框-->
          <div class="all-width pl-md pr-md mt-12">
            <nz-input-group [nzPrefix]="searchIcon" *ngIf="isAll" [nzSuffix]="clearAllIcon">
              <input [ngModel]="leftSearchAll" nz-input class="selfRadius" placeholder="搜索全部人员"
                (keydown.enter)="$event.target.blur()" (blur)="searchEmployee($event)" />
              <ng-template #clearAllIcon>
                <i nz-icon nzType="close-circle" nzTheme="outline" *ngIf="leftSearchAll != ''"
                  class="text-gray1 clickEle" (click)="clearSearch()"></i>
              </ng-template>
            </nz-input-group>
            <nz-input-group [nzPrefix]="searchIcon" *ngIf="!isAll" [nzSuffix]="clearRecommendIcon">
              <input [(ngModel)]="leftSearchRecommend" nz-input class="selfRadius" placeholder="搜索推荐人员"
                (keydown.enter)="$event.target.blur()" (blur)="searchRecommend()" />
              <ng-template #clearRecommendIcon>
                <i nz-icon nzType="close-circle" nzTheme="outline" *ngIf="leftSearchRecommend != ''"
                  class="text-gray1 clickEle" (click)="clearSearch()"></i>
              </ng-template>
            </nz-input-group>
          </div>
          <!--            中部搜索框 End-->
          <!--            底部选择框-->
          <div *ngIf="!isAll" class="all-width pl-md pr-md">
            <div class="text-gray3 mt-12 mb-12">{{ checkTitle }}</div>
            <!--            推荐数据展示部分-->
            <ng-container *ngIf="showRecommendData.length > 0">
              <label nz-checkbox [(ngModel)]="recommendCheckAll" class="select-item ml-12"
                (ngModelChange)="allRecommendCheck($event)" *ngIf="!nzMultiple">全选</label>
              <cdk-virtual-scroll-viewport [itemSize]="54" style="width: 100%" [ngStyle]="{
                  height:
                    checkTitle == '' && nzMultiple
                      ? '360px'
                      : checkTitle == '' && !nzMultiple
                      ? '328px'
                      : checkTitle != '' && nzMultiple
                      ? '316px'
                      : '290px'
                }">
                <ng-container *ngFor="let item of showRecommendData; let index = index">
                  <div class="employee-item pl-12 clickEle flexRow">
                    <label nz-checkbox [ngModel]="selectIds.indexOf(item['key']) > -1"
                      (ngModelChange)="selectRecommend(item['key'], index, $event)" style="min-width: 16px"
                      class="mr-sm" *ngIf="!nzMultiple">
                    </label>

                    <div class="employee-item-info flexColumn" (click)="selectRecommend(item['key'], index, $event)">
                      <div>
                        <i nz-icon nzIconfont="icon_user" class="structure-icon mr-xs mt-xs"></i>
                        {{ item['title'] }}
                      </div>
                      <div style="max-width: 370px; padding-left: 20px" class="text-gray1 mt-xs text-truncate">
                        {{ item['organ_all_path'] }}
                      </div>
                    </div>
                  </div>
                </ng-container>
              </cdk-virtual-scroll-viewport>
            </ng-container>
            <!--            推荐数据展示部分 End-->
            <!--            推荐数据为空时展示-->
            <ng-container *ngIf="showRecommendData.length == 0">
              <div class="no-data-box">
                <img src="assets/no-data.png" class="no-data-img" />
                <div class="text-gray2 all-width text-center">暂无数据</div>
              </div>
            </ng-container>
            <!--            推荐数据为空时展示 End-->
          </div>
          <!--          全部数据部分-->
          <div *ngIf="isAll" class="all-width pt-12 pl-md pr-md">
            <nz-tree [nzData]="allStructure" [nzSelectedKeys]="selectIds" nzMultiple nzCheckStrictly
              nzVirtualHeight="360px" [nzTreeTemplate]="structureTpl" (nzExpandChange)="getEmployee($event)"
              (nzClick)="getEmployee($event)" [ngClass]="{ 'd-none': leftSearchAll != '' }">
              <ng-template #structureTpl let-node>
                <div (click)="test(node)">
                  <!--<i nz-icon nzIconfont="icon_jiagou" *ngIf="node.level == 0" class="structure-icon mr-sm"></i>
                  <i
                    nz-icon
                    nzIconfont="icon_pianqu"
                    *ngIf="node.origin['organ_type'] == 1 && node.origin['organ_type_extra'] == 2"
                    class="structure-icon mr-sm"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont="icon_arrive"
                    *ngIf="node.origin['organ_type'] == 1 && node.origin['organ_type_extra'] == 3"
                    class="structure-icon mr-sm"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont="icon_zu"
                    *ngIf="(node.origin['organ_type_extra'] == 0 || node.origin['organ_type_extra'] == 4) && node.level > 0"
                    class="structure-icon mr-sm"
                  ></i>
                  <i nz-icon nzIconfont="icon_user" *ngIf="node.origin['employee_id'] > 6" class="structure-icon mr-sm"></i>
                  &lt;!&ndash;                  <i nz-icon nzIconfont='icon_zu' class='structure-icon mr-sm' *ngIf="!node.origin['isEmployee']"></i>&ndash;&gt;
                  <i nz-icon nzIconfont="icon_user" class="structure-icon mr-sm" *ngIf="node.origin['isEmployee']"></i>-->
                  <i nz-icon nzIconfont="icon_institution" class="structure-icon mr-sm"
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 1"></i>
                  <i nz-icon nzIconfont="icon_equally" class="structure-icon mr-sm"
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 2"></i>
                  <i nz-icon nzIconfont="icon_company" class="structure-icon mr-sm"
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 3"></i>
                  <i nz-icon nzIconfont="icon_supply" class="structure-icon mr-sm"
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 4"></i>
                  <i nz-icon nzIconfont="icon_jiagou" class="structure-icon mr-sm"
                    *ngIf="node.level != 0 && node.origin['organ_type_extra'] == 1"></i>
                  <i nz-icon nzIconfont="icon_pianqu" class="structure-icon mr-sm"
                    *ngIf="node.level != 0 && node.origin['organ_type_extra'] == 2"></i>
                  <i nz-icon nzIconfont="icon_arrive" class="structure-icon mr-sm"
                    *ngIf="node.level != 0 && node.origin['organ_type'] == 1 && node.origin['organ_type_extra'] == 3"></i>
                  <i nz-icon nzIconfont="icon_jiagou" class="structure-icon mr-sm"
                    *ngIf="node.level != 0 && node.origin['organ_type'] != 1 && node.origin['organ_type_extra'] == 3"></i>
                  <i nz-icon nzIconfont="icon_zu" class="structure-icon mr-sm"
                    *ngIf="node.level != 0 && node.origin['organ_type_extra'] == 4"></i>
                  <i nz-icon nzIconfont="icon_duties" class="structure-icon mr-sm"
                    *ngIf="node.origin['organ_type'] == 5"></i>
                  <i nz-icon nzIconfont="icon_user" class="structure-icon mr-sm" *ngIf="node.origin['isEmployee']"></i>
                  {{ node.title }}
                </div>
              </ng-template>
            </nz-tree>
            <div class="text-gray3 mt-12 mb-12">{{ checkTitle }}</div>
            <!--           全部数据展示部分-->
            <ng-container *ngIf="showSearchData.length > 0 && leftSearchAll != ''">
              <label nz-checkbox [(ngModel)]="searchCheckAll" class="select-item ml-12"
                (ngModelChange)="checkAllSearch($event)" *ngIf="!nzMultiple">全选</label>
              <ng-container>
                <cdk-virtual-scroll-viewport [itemSize]="54" style="width: 100%" [ngStyle]="{
                    height:
                      checkTitle == '' && nzMultiple
                        ? '344px'
                        : checkTitle == '' && !nzMultiple
                        ? '312px'
                        : checkTitle != '' && nzMultiple
                        ? '300px'
                        : '274px'
                  }">
                  <div *ngFor="let item of showSearchData; let index = index"
                    class="employee-item pl-12 clickEle flexRow">
                    <label nz-checkbox [ngModel]="selectIds.indexOf(item['key']) > -1"
                      (ngModelChange)="selectEmployee(item)" style="min-width: 16px" class="mr-sm">
                    </label>

                    <div class="employee-item-info flexColumn" (click)="selectEmployee(item)">
                      <div>
                        <i nz-icon nzIconfont="icon_user" class="structure-icon mr-xs mt-xs"></i>
                        {{ item['title'] }}
                      </div>
                      <div style="max-width: 370px; padding-left: 20px" class="text-gray1 mt-xs text-truncate">
                        {{ item['organ_all_path'] }}
                      </div>
                    </div>
                  </div>
                </cdk-virtual-scroll-viewport>
              </ng-container>
            </ng-container>
            <!--            推荐数据展示部分 End-->
            <!--            推荐数据为空时展示-->
            <ng-container *ngIf="showSearchData.length == 0 && showAllNoData">
              <div class="no-data-box">
                <img src="assets/no-data.png" class="no-data-img" />
                <div class="text-gray2 all-width text-center">暂无数据</div>
              </div>
            </ng-container>
            <!--            推荐数据为空时展示 End-->
          </div>
          <!--          全部数据部分 End-->
          <!--            底部选择框 End-->
        </div>
        <div class="result-box flexFull flexColumn">
          <!--            顶部title-->
          <div class="box-title pl-12 flexRow">
            <div>已选人员</div>
            <div class="ml-sm text-xs text-gray1">({{ selectIds.length }}项)</div>
            <div class="flexFull"></div>
            <div class="mr-md text-primary clickEle" (click)="clear()">清空</div>
          </div>
          <!--            顶部title End-->
          <!--            中部搜索框-->
          <div class="all-width pl-md pr-md mt-12">
            <nz-input-group [nzPrefix]="searchIcon">
              <input nz-input class="selfRadius" placeholder="搜索人员" [ngModel]="rightSearch"
                (ngModelChange)="setRightSearch($event)" />
            </nz-input-group>
          </div>
          <!--            中部搜索框 End-->
          <div class="all-width pl-md pr-md mt-12">
            <cdk-virtual-scroll-viewport [itemSize]="40" style="height: 362px">
              <ng-container *ngFor="let item of selectResult; let index = index">
                <div *ngIf="rightSearch == '' || item['title'].indexOf(rightSearch) > -1"
                  class="select-result-item mb-sm pl-12 flexRow pr-md">
                  <i nz-icon nzIconfont="icon_user" class="structure-icon mr-sm"></i>
                  <div class="flexFull">{{ item['title'] }}</div>
                  <i nz-icon nzType="close-circle" nzTheme="outline" class="text-gray1 clickEle"
                    (click)="delete(item, index)"></i>
                </div>
              </ng-container>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </div>
    </div>
    <!--   如果当前模式是选择管理岗End -->
  </ng-template>
</my-feedback>
<ng-template #searchIcon>
  <i nz-icon nzIconfont="icon_search" class="text-gray1"></i>
</ng-template>